import * as Yup from 'yup';

const getValidationSchema = (intl) =>
    Yup.object().shape({
        name: Yup.string()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .nullable()
    });

export default getValidationSchema;